/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightCheckoutAction
 */
export interface FlightCheckoutAction {
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutAction
     */
    actionId: string;
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutAction
     */
    type: FlightCheckoutActionTypeEnum;
    /**
     *
     * @type {Date}
     * @memberof FlightCheckoutAction
     */
    expiresAt: Date | null;
    /**
     * Transient hosted action material; it may be null on later status reads.
     * @type {string}
     * @memberof FlightCheckoutAction
     */
    continuationUrl: string | null;
}


/**
 * @export
 */
export const FlightCheckoutActionTypeEnum = {
    ThreeDs: 'three_ds'
} as const;
export type FlightCheckoutActionTypeEnum = typeof FlightCheckoutActionTypeEnum[keyof typeof FlightCheckoutActionTypeEnum];


/**
 * Check if a given object implements the FlightCheckoutAction interface.
 */
export function instanceOfFlightCheckoutAction(value: object): value is FlightCheckoutAction {
    if (!('actionId' in value) || value['actionId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('continuationUrl' in value) || value['continuationUrl'] === undefined) return false;
    return true;
}

export function FlightCheckoutActionFromJSON(json: any): FlightCheckoutAction {
    return FlightCheckoutActionFromJSONTyped(json, false);
}

export function FlightCheckoutActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightCheckoutAction {
    if (json == null) {
        return json;
    }
    return {

        'actionId': json['action_id'],
        'type': json['type'],
        'expiresAt': (json['expires_at'] == null ? null : new Date(json['expires_at'])),
        'continuationUrl': json['continuation_url'],
    };
}

export function FlightCheckoutActionToJSON(json: any): FlightCheckoutAction {
    return FlightCheckoutActionToJSONTyped(json, false);
}

export function FlightCheckoutActionToJSONTyped(value?: FlightCheckoutAction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'action_id': value['actionId'],
        'type': value['type'],
        'expires_at': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
        'continuation_url': value['continuationUrl'],
    };
}
